import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button } from '@lt/components';

import { Check } from '@lt/components/icons-react';
import Certificate from './Certificate';
import { CERTIFICATE_DESIGNS } from '../store/certificate/constants';

const ActiveIcon = () => (
  <StyledActiveIcon>
    <Check width="12px" height="20px" />
  </StyledActiveIcon>
);

const DesignSelector = ({ design, setDesign, disabled }) => (
  <StyledContainer>
    {Object.keys(CERTIFICATE_DESIGNS).map((designName) => {
      const isActive = design === designName;
      return (
        <StyledButton
          functional
          disabled={disabled}
          onClick={() => setDesign(designName)}
          isActive={isActive}
          key={designName}
        >
          {isActive && <ActiveIcon />}
          <StyledCertificate
            design={CERTIFICATE_DESIGNS[designName]}
            width={61}
          />
        </StyledButton>
      );
    })}
  </StyledContainer>
);

DesignSelector.propTypes = {
  design: PropTypes.string.isRequired,
  setDesign: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DesignSelector.defaultProps = {
  disabled: false,
};

const StyledButton = styled(Button)`
  position: relative;
  padding: 6px;
  display: flex;
  box-sizing: border-box;
  width: 75px;
  justify-content: center;
  border-radius: 2px;

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid;
      border-color: ${({ theme }) => theme.colors.blue};
    `};
`;

const StyledActiveIcon = styled.div`
  position: absolute;
  z-index: 2;
  top: -10px;
  display: flex;
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 50%;
  box-shadow: 2px 3px 4px 0 rgba(23, 24, 26, 0.46);

  path {
    stroke: ${({ theme }) => theme.colors.white};
  }
`;

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

const StyledCertificate = styled(Certificate)``;

export default DesignSelector;
